export const zh = {
  translation: {
    post: "发布",
    remove_post: "移除帖子",
    no_posts: "没有帖子。",
    create_a_post: "发帖",
    create_post: "发表帖子",
    number_of_posts_0: "{{formattedCount}} 条帖子",
    posts: "帖子",
    related_posts: "这些帖子可能与之相关",
    cross_posts: "此链接也被分享到:",
    cross_post: "转发",
    cross_posted_to: "已转发到: ",
    comments: "评论",
    number_of_comments_0: "{{formattedCount}} 条评论",
    remove_comment: "移除评论",
    communities: "社区",
    users: "用户",
    create_a_community: "创建新社区",
    select_a_community: "选择一个社区",
    create_community: "创建社区",
    remove_community: "移除社区",
    subscribed_to_communities: "已订阅 <1>社区</1>",
    trending_communities: "热门<1>社区</1>",
    list_of_communities: "社区列表",
    number_of_communities_0: "{{formattedCount}} 个社区",
    community_reqs: "小写字母、下划线（_）且不含空格。",
    invalid_community_name: "无效名称。",
    create_private_message: "创建私信",
    send_secure_message: "发送安全消息",
    send_message: "发送消息",
    message: "消息",
    edit: "编辑",
    reply: "回复",
    more: "更多",
    cancel: "取消",
    preview: "预览",
    upload_image: "上传图片",
    avatar: "头像",
    upload_avatar: "上传头像",
    banner: "横幅",
    upload_banner: "上传横幅",
    icon: "图标",
    upload_icon: "上传图标",
    show_avatars: "显示头像",
    show_context: "显示上下文",
    formatting_help: "格式化帮助",
    sorting_help: "排序帮助",
    view_source: "查看源代码",
    unlock: "解除锁定",
    lock: "加锁",
    sticky: "置顶",
    unsticky: "取消置顶",
    link: "链接",
    archive_link: "存档链接",
    bold: "粗体",
    italic: "斜体",
    subscript: "下标",
    superscript: "上标",
    header: "标题",
    strikethrough: "删除线",
    quote: "引用",
    spoiler: "剧透折叠",
    list: "列表",
    mod: "社区管理",
    mods: "社区管理",
    moderates: "管理",
    settings: "设置",
    admin_settings: "管理员设置",
    site_config: "网站配置",
    remove_as_mod: "删除社区管理权限",
    appoint_as_mod: "指派为社区管理",
    leave_mod_team: "离开管理团队",
    modlog: "管理日志",
    admin: "实例管理",
    admins: "实例管理",
    remove_as_admin: "移除实例管理权限",
    appoint_as_admin: "指派为实例管理",
    remove: "移除",
    removed: "已被社区管理移除",
    locked: "已锁定",
    stickied: "已置顶",
    reason: "原因",
    mark_as_read: "标记为已读",
    mark_as_unread: "标记为未读",
    delete: "删除",
    deleted: "已被作者删除",
    delete_account: "删除账号",
    delete_account_confirm: "警告：这将永久删除您的帐户。删除可能不会总是同步到其他实例。请输入您的密码以确认操作。",
    click_to_delete_picture: "点击删除图片：{{filename}}",
    picture_deleted: "图片已删除：{{filename}}",
    restore: "恢复",
    ban: "封禁",
    ban_from_site: "全站封禁",
    unban: "解封",
    unban_from_site: "取消全站封禁",
    banned: "已封禁",
    banned_users: "被封禁的用户",
    save: "保存",
    unsave: "取消保存",
    create: "创建",
    creator: "创建者",
    username: "用户名",
    email_or_username: "邮箱或用户名",
    number_of_users: "{{formattedCount}} 用户",
    number_of_subscribers: "{{formattedCount}} 订阅者",
    number_of_points_0: "{{formattedCount}} 分",
    name: "名称",
    name_explain: "名称 - 作为社区的标识符号，将来不能更改。",
    display_name: "显示名称",
    display_name_explain: "显示名称 — 在社区页面上显示的标题，将来可以更改。",
    title: "标题",
    subscribers: "订阅",
    both: "全部",
    saved: "保存",
    unsubscribe: "取消订阅",
    subscribe: "订阅",
    subscribed: "已订阅",
    prev: "上一页",
    next: "下一页",
    sidebar: "介绍",
    sort_type: "排序方式",
    hot: "最热",
    active: "活跃",
    new: "最新",
    old: "最早",
    most_comments: "最多评论",
    new_comments: "最新评论",
    day: "日",
    week: "周",
    month: "月",
    number_of_months: "{{formattedCount}} 月",
    all: "所有",
    local: "本地",
    top: "最热",
    api: "API",
    docs: "文档",
    inbox: "收件箱",
    inbox_for: "<1>{{user}}</1> 的收件箱",
    mark_all_as_read: "全部标为已读",
    type: "类型",
    unread: "未读",
    replies: "回复",
    mentions: "提及",
    reply_sent: "回复已发送",
    message_sent: "消息已发送",
    search: "搜索",
    overview: "概况",
    view: "查看",
    logout: "登出",
    login_sign_up: "登录/注册",
    login: "登录",
    sign_up: "注册",
    notifications_error: "你的浏览器不支持桌面通知，可尝试 Firefox 或 Chrome。",
    unread_messages: "{{formattedCount}} 未读消息",
    messages: "消息",
    password: "密码",
    invalid_password: "密码长度应在10到60个字符之间。",
    verify_password: "验证密码",
    old_password: "旧密码",
    forgot_password: "忘记密码",
    reset_password_mail_sent: "已发送重置密码的邮件。",
    password_change: "密码更改",
    new_password: "新密码",
    no_email_setup: "此服务器还未正确进行邮件发送配置。",
    email: "邮箱",
    matrix_user_id: "Matrix 用户",
    private_message_disclaimer: "警告：Lemmy 中的私信不是端到端加密的，因此发送方和接收方实例的管理员在技术上能够阅读它们。对于敏感消息，请考虑使用 <1>Matrix</1>。",
    send_notifications_to_email: "发送通知到邮箱",
    optional: "可选",
    expires: "过期",
    language: "语言",
    downvotes_disabled: "点踩已禁用",
    enable_downvotes: "启用点踩",
    upvote: "点赞",
    number_of_upvotes_0: "{{formattedCount}} 个点赞",
    downvote: "点踩",
    number_of_downvotes_0: "{{formattedCount}} 个点踩",
    open_registration: "开放注册",
    registration_closed: "注册通道已关闭",
    enable_nsfw: "启用 NSFW",
    url: "URL",
    body: "内容",
    copy_suggested_title: "复制建议的标题: {{title}}",
    community: "社区",
    expand_here: "展开",
    subscribe_to_communities: "订阅一些 <1>社区</1>。",
    chat: "聊天",
    recent_comments: "最新评论",
    no_results: "没有结果。",
    setup: "设置",
    lemmy_instance_setup: "Lemmy 实例设置",
    setup_admin: "设置站点管理员",
    modified: "修改",
    nsfw: "工作场所不宜",
    show_nsfw: "显示 NSFW 内容",
    theme: "主题",
    code: "代码",
    joined: "已加入",
    join_lemmy: "加入 Lemmy",
    support_lemmy: "支持Lemmy",
    by: " ",
    to: "发于",
    from: "来自",
    transfer_community: "转让社区",
    transfer_site: "站点转让",
    are_you_sure: "你确定吗？",
    yes: "是",
    no: "否",
    not_logged_in: "未登录。",
    bio_length_overflow: "用户简介不能超过1000个字符。",
    logged_in: "已登录。",
    must_login: "您必须<1>登录</1>或<2>注册</2>才能发表评论。",
    site_saved: "站点已保存。",
    community_ban: "你已被此社区封禁。",
    site_ban: "你已被本站封禁",
    couldnt_create_comment: "无法创建评论。",
    couldnt_like_comment: "无法点赞评论。",
    couldnt_update_comment: "无法更新评论。",
    couldnt_save_comment: "无法保存评论。",
    couldnt_get_comments: "无法获取评论。",
    no_comment_edit_allowed: "没有编辑评论的权限。",
    no_post_edit_allowed: "没有编辑帖子的权限。",
    no_community_edit_allowed: "没有编辑社区的权限。",
    couldnt_find_community: "无法找到社区。",
    couldnt_update_community: "无法更新社区。",
    community_already_exists: "社区已存在。",
    community_moderator_already_exists: "社区管理已存在。",
    community_follower_already_exists: "社区关注者已存在。",
    community_user_already_banned: "社区用户已被封禁。",
    couldnt_create_post: "无法创建帖子。",
    couldnt_like_post: "无法点赞帖子。",
    couldnt_find_post: "无法找到帖子。",
    couldnt_get_posts: "无法获取帖子",
    couldnt_update_post: "无法更新帖子",
    couldnt_save_post: "无法保存帖子。",
    couldnt_find_parent_comment: "找不到上级评论。",
    parent_comment_not_in_post: "上级评论属于另一篇帖子。",
    no_slurs: "禁止侮辱性言论。",
    not_an_admin: "不是站点管理。",
    not_a_moderator: "不是社区管理。",
    site_already_exists: "站点已存在。",
    couldnt_update_site: "无法更新站点。",
    couldnt_find_that_username_or_email: "用户名/邮箱不存在。",
    password_incorrect: "密码不正确。",
    passwords_dont_match: "密码不匹配。",
    no_password_reset: "没有邮箱，您将无法重设密码。",
    captcha_incorrect: "验证码不正确。",
    enter_code: "输入代码",
    invalid_username: "用户名无效。",
    admin_already_created: "抱歉，管理员已存在。",
    user_already_exists: "用户已存在。",
    email_already_exists: "邮箱已被占用。",
    couldnt_update_user: "无法更新用户。",
    system_err_login: "系统错误。请尝试登出后重新登入。",
    couldnt_create_private_message: "无法创建私信。",
    no_private_message_edit_allowed: "没有编辑私信的权限。",
    couldnt_update_private_message: "无法更新私信。",
    time: "时间",
    action: "动作",
    emoji_picker: "表情选择器",
    block_leaving: "确定要离开吗？",
    what_is: "什么是",
    cake_day_title: "加入日期:",
    cake_day_info: "今天是{{creator_name}}的加入周年纪念日！",
    invalid_post_title: "无效的帖子标题",
    invalid_url: "无效 URL。",
    play_captcha_audio: "播放验证码音频",
    bio: "简介",
    instances: "实例",
    linked_instances: "已关联的实例",
    allowed_instances: "允许的实例",
    blocked_instances: "被屏蔽的实例",
    none_found: "未找到任何内容。",
    report_reason_required: "需要填写举报理由。",
    report_too_long: "举报过长。",
    couldnt_create_report: "无法创建举报。",
    couldnt_resolve_report: "无法解决举报。",
    expand: "展开",
    collapse: "折叠",
    captcha: "验证码",
    not_a_mod_or_admin: "不是社区或站点管理。",
    site_description_length_overflow: "网站描述不能超过150字符。",
    invalid_matrix_id: "matrix用户无效。必须是 @用户:实例.域名",
    show_scores: "显示分数",
    bot_account: "机器人帐户",
    show_bot_accounts: "显示机器人帐户",
    remove_content: "移除内容",
    remove_content_more: "移除帖子，评论和社区",
    explore_communities: "探索社区",
    trending: "热门",
    description: "描述",
    active_users_in_the_last_day_0: "近一天 {{formattedCount}} 人活跃",
    active_users_in_the_last_week_0: "近一周 {{formattedCount}} 人活跃",
    active_users_in_the_last_month_0: "近一月 {{formattedCount}} 人活跃",
    active_users_in_the_last_six_months_0: "近半年 {{formattedCount}} 人活跃",
    weak: "弱",
    medium: "中等",
    strong: "强",
    show_read_posts: "显示已读帖子",
    subscribed_description: "显示已订阅的社区",
    number_of_days: "天数",
    all_description: "显示所有社区，包括外站社区",
    couldnt_mark_post_as_read: "无法将帖子标记为已读。",
    very_weak: "很弱",
    profile: "帐户",
    only_admins_can_create_communities: "只有实例管理可以创建社区",
    comment_here: "在此处输入评论...",
    local_description: "只显示本站社区",
    change_password: "更改密码",
    unread_reports: "{{formattedCount}} 条未读举报",
    unread_registration_applications: "{{formattedCount}} 条未读申请",
    password_changed: "密码已更改。",
    community_creation_admin_only: "仅管理员可以创建社区",
    created: "创建",
    couldnt_find_comment: "无法找到评论。",
    fill_out_application: "要加入此服务器,你需要填写此申请并等待审核。",
    email_verified: "你的邮箱已通过验证。",
    cannot_leave_admin: "你无法让此实例处于没有管理员的状态",
    leave_admin_team: "离开管理团队",
    left_admin_team: "你已离开管理团队",
    blocked_communities: "被屏蔽的社区",
    blocked_users: "被屏蔽的用户",
    block_user: "屏蔽用户",
    unblock_community: "取消屏蔽社区",
    unblock_user: "取消屏蔽用户",
    person_block: "此用户已屏蔽你。",
    blocks: "屏蔽",
    require_registration_application: "需要申请注册",
    default_theme: "默认主题",
    listing_type: "列表类型",
    websocket_reconnected: "Websocket已重新连线",
    websocket_disconnected: "Websocket断线",
    blocked: "已屏蔽",
    block_community: "屏蔽社区",
    unblocked: "取消屏蔽",
    reports: "举报",
    reporter: "举报人",
    unresolved_by: "由<1></1>设为未解决",
    resolved_by: "由<1></1>解决",
    show_report_dialog: "显示举报对话框",
    create_report: "创建举报",
    resolve_report: "解决举报",
    unresolve_report: "取消解决举报",
    report_created: "举报已创建。",
    answer: "答复",
    verify_email: "验证邮箱",
    verify_email_sent: "验证邮件已发送。",
    registration_application_sent: "注册申请已发送。",
    application_questionnaire: "申请问卷",
    require_email_verification: "需要验证邮箱",
    private_instance: "私有实例",
    registration_application_pending: "注册等待批准。",
    registration_denied: "申请被拒绝。",
    email_not_verified: "邮箱未验证。",
    email_required: "需要邮箱。",
    registration_application_answer_required: "需要注册申请。",
    instance_is_private: "此实例是私有的。",
    apply_to_join: "申请加入",
    registration_applications: "注册申请",
    applicant: "申请人",
    deny_reason: "拒绝原因",
    approved_by: "已被 <1></1> 批准",
    denied_by: "已被 <1></1> 拒绝",
    approve: "批准",
    deny: "拒绝",
    required: "必填",
    only_mods_can_post_in_community: "只有社区管理才能在此社区发帖",
    legal_information: "条款",
    purge_warning: "警告：清除操作将从数据库中删除目标项及其所有子项，并且无法恢复。请务必谨慎使用此功能。",
    language_select_placeholder: "选择语言",
    rate_limit_message: "消息",
    per_second: "每秒",
    column_imageurl: "图片 URL",
    custom_emojis: "自定义表情",
    loading: "加载中",
    purge_comment: "清除评论",
    purge_post: "清除贴文",
    purge: "清除",
    purge_community: "清除社区",
    hard: "困难",
    profile_not_logged_in_alert: "您尚未登录。您可以使用一个能关注用户的联邦宇宙帐户来关注此用户。",
    community_not_logged_in_alert: "您尚未登录。但是您可以使用 Lemmy 或 Mastodon 等其他联邦宇宙帐户进行订阅。为此，请将以下内容粘贴到您所在实例的搜索框中：<1>!{{community}}@{{instance}}</1>",
    modlog_content_warning: "<1>内容警告</1>：某些已被删除的帖子可能包含令人不适的内容或成人内容。请谨慎操作。",
    too_many_images_upload_0: "超过最大可上传图片数 {{formattedCount}} 。请少选择一些图片。",
    view_all_comments: "查看所有评论",
    undistinguish: "作为用户发言",
    failed_to_delete_picture: "删除图片失败：{{filename}}",
    jump_to_content: "跳转到内容",
    filter_by_mod: "根据管理员筛选",
    ban_from_community: "从社区禁止",
    reset_password: "重置密码",
    application_email_admins: "收到新申请时发送邮件给管理员",
    purge_user: "清除用户",
    upload_too_large: "所上传的图片太大了！",
    filter_by_user: "根据用户筛选",
    purge_success: "该物品已成功清除。",
    reports_email_admins: "收到新举报时发送邮件给管理员",
    application_email_reason_none: "申请被拒绝",
    subscribe_pending: "订阅待处理",
    distinguish: "作为管理员发言",
    filter_by_action: "根据操作筛选",
    undetermined_language_warning: "警告：如果取消选中\"未确定\"，您将看不到大部分内容。",
    scaled: "各版热议",
    moderator_view: "管理视图",
    moderator_view_description: "只显示你在自己管理的社区的贡献",
    x_more_replies: "{{formattedCount}} 更多回复",
    interface_language: "界面语言",
    registration_mode: "注册模式",
    close_registration: "关闭注册",
    site: "地址",
    controversial: "有争议的",
    fetching_community: "正在获取 {{community}}",
    removed_post: "帖子已被移除",
    restored_post: "帖子已被恢复",
    undistinguished_comment: "普通评论",
    pictures_uploaded_progess: "已上传 {{uploaded}}/{{total}} 张图片",
    appoint_as_mod_are_you_sure: "您确定要指派 {{user}} 为 {{community}} 的社区管理吗？",
    remove_as_admin_are_you_sure: "您确定要将 {{user}} 从 {{instance}} 管理团队中移除吗？",
    appoint_as_admin_are_you_sure: "您确定要指派 {{user}} 为 {{instance}} 的管理员吗？",
    ban_from_community_with_name: "在 {{community}} 中封禁 {{user}}",
    banned_from_site: "已封禁 {{user}}",
    purge_user_with_name: "清除 {{user}}",
    error_page_paragraph: "服务器出现错误。请尝试刷新您的浏览器。如果这样做不起作用，请稍后再试。",
    transfer_community_are_you_sure: "您确定要将 {{community}} 转让给 {{user}} 吗？",
    site_name_length_overflow: "网站名称不能超过 20 个字符",
    hide_modlog_mod_names: "隐藏管理记录中的社区管理名称",
    federation_strict_allowlist: "联合严格允许列表",
    rate_limit_header: "频率限制选项",
    feature_in_community: "在社区中精选",
    custom_emoji_save_validation: "必须填写所有字段，且短代码不能重复。",
    open_links_in_new_tab: "在新标签页中打开链接",
    remote_follow_prompt: "输入您想关注的社区实例",
    show_password: "显示密码",
    hide_password: "隐藏密码",
    community_federated: "社区已联合！",
    blur_nsfw: "模糊NSFW内容",
    error_code_message: "服务器返回此错误： <1>{{error}}</1>。 这可能有助于管理员和开发人员诊断和修复错误",
    import_export_section_title: "导入/导出设置",
    import_export_section_description: "以 JSON 格式导入和导出帐户设置",
    export_file_name: "lemmy_用户设置",
    export: "导出",
    import: "导入",
    exporting: "正在导出",
    importing: "正在导入",
    import_export_rate_limit_error: "请等待几分钟后再尝试导入或导出设置",
    export_error: "导出设置出错",
    import_error: "导入设置出错",
    import_success: "设置已成功导入！",
    block_instance: "屏蔽实例",
    unblock_instance: "取消屏蔽实例",
    rate_limit_post: "帖子",
    rate_limit_register: "注册",
    software: "软件",
    version: "版本",
    column_emoji: "表情",
    emojis: "表情",
    emoji: "表情",
    cant_enable_private_instance_and_federation_together: "无法同时启用私有实例和联合功能",
    remove_instance: "删除实例",
    rate_limit_error: "请求太多，稍后再试。",
    could_not_fetch_community: "无法获取 {{community}}",
    remote_follow: "远程关注",
    remote_follow_modal_title: "从远程实例订阅",
    remote_follow_invalid_instance: "{{instance}}不是一个有效域名。",
    disable_totp: "禁用双因素身份验证",
    totp_qr: "双因素认证二维码",
    totp_qr_segue: "或在验证器应用程序中扫描此二维码",
    enable_totp_success: "成功启用双因素身份验证",
    disable_totp_success: "成功禁用双因素身份验证",
    remote_follow_local_instance: "无法获取要发起跨站关注的本站实例",
    restore_post: "恢复帖子",
    removed_comment: "评论已被移除",
    restore_comment: "恢复评论",
    restored_comment: "评论已被恢复",
    distinguished_comment: "杰出评论",
    remove_as_mod_are_you_sure: "您确定要删除 {{user}} 在 {{community}} 中的社区管理身份吗？",
    removed_mod: "社区管理已被移除",
    removing_mod: "正在移除社区管理",
    appointing_mod: "正在指派社区管理",
    appointed_mod: "已指派社区管理",
    removing_admin: "正在移除实例管理",
    removed_admin: "实例管理已被移除",
    appointing_admin: "正在指派管理",
    appointed_admin: "已指派实例管理",
    removing: "正在移除",
    unlocked: "已解除锁定",
    locked_post: "已锁定的帖子",
    unlocked_post: "已解除锁定的帖子",
    deleted_post: "已删除的帖子",
    deleted_comment: "已删除的评论",
    undelete: "取消删除",
    undeleted_post: "已取消删除的帖子",
    undeleted_comment: "已取消删除的评论",
    restoring: "正在恢复",
    permanently_ban: "永久封禁",
    ban_with_name: "封禁 {{user}}",
    banning: "正在封禁 {{user}}",
    unban_with_name: "解封 {{user}}",
    unbanning: "正在解封 {{user}}",
    unban_from_community: "取消社区封禁",
    unban_from_community_with_name: "在 {{community}} 解封 {{user}}",
    banned_from_community: "已在 {{community}} 封禁 {{user}}",
    unbanned_from_community: "在 {{community}} 解封 {{user}}",
    unbanned_from_site: "已解封 {{user}}",
    purging: "正在清除",
    error_page_title: "错误!",
    error_page_admin_matrix: "如果您想联系 {{instance}} 管理员寻求支持，请尝试使用以下 Matrix 地址：",
    not_found_page_title: "页面未找到",
    not_found_page_message: "您要查找的页面不存在。",
    not_found_return_home_button: "单击此处返回主页",
    days_until_expiration: "天后到期",
    transferring_community: "正在转让社区",
    transfered_community: "社区已转让",
    site_name_required: "需要网站名称。",
    creating_report: "正在创建举报",
    report_post: "举报帖子",
    report_comment: "举报评论",
    report_message: "举报信息",
    slur_filter_regex: "污辱词过滤正则表达式",
    invalid_regex: "正则表达式无效。",
    permissive_regex: "正则表达式将与任何提供的文本进行匹配。",
    actor_name_max_length: "请求体名称最大长度",
    federation_enabled: "启用联合",
    federation_debug: "联合调试模式",
    federation_http_fetch_retry_limit: "联合 HTTP 取回重试上限",
    federation_worker_count: "联合 Worker 数量",
    easy: "容易",
    rate_limit: "频率限制",
    rate_limit_image: "图片",
    rate_limit_comment: "评论",
    rate_limit_search: "搜索",
    taglines: "标语",
    add_tagline: "添加标语",
    featured: "加精",
    featured_in_local: "已在本地精选",
    featured_in_community: "已在社区中精选",
    feature_in_local: "在本地精选",
    unfeature_from_local: "取消在本地精选",
    unfeature_from_community: "取消在社区中精选",
    featured_post: "已加精帖子",
    unfeatured_post: "已取消加精帖子",
    deleted_emoji: "已删除的表情",
    saved_emoji: "已保存的表情",
    add_custom_emoji: "添加自定义表情",
    column_keywords: "关键词（空格分隔）",
    column_alttext: "替代文本",
    column_shortcode: "短代码",
    column_category: "分类",
    invalid_totp_code: "2FA 代码无效： 必须为六位数字符串",
    incorrect_totp_code: "不正确的2FA代码",
    enable_totp: "启用双因素身份验证",
    enter_totp_code: "输入您的 2FA 代码",
    totp_link: "单击此处获取 2FA 安装链接",
    add_instance: "添加实例",
    op: "楼主",
    couldnt_create_audio_captcha: "无法创建音频验证码。",
    incorrect_login: "登录凭证不正确",
    fetch_community: "获取社区",
    confirmation_required: "需要确认",
    view_votes: "查看投票",
    votes: "投票",
    submit: "提交",
    denied: "被拒绝",
    community_locked: "社区已被锁定",
    community_locked_message: "<1>此社区已被锁定:</1> 只有社区管理可以创建帖子。 您仍然可以对帖子发表评论。",
    number_of_local_subscribers_0: "{{formattedCount}} 本站订阅者",
    community_visibility: "可见性",
    delete_account_content: "删除所有帖子、评论和上传的图片",
    public_blurb: "该社区可以联合到其他实例，并允许其它实例的用户发贴/评论。",
    show_upvotes: "显示顶数",
    show_upvote_percentage: "显示顶数百分比%",
    show_downvotes: "显示踩数",
    uploader: "上传者",
    uploads: "上传",
    banned_from_community_blurb: "<1>您已被封禁：</1>您不能在此社区发帖、发表评论或投票。 不过，您仍然可以自由浏览。",
    private_message_form_user_matrix_blurb: "该用户已经有一个Matrix帐户，您可以在该 <1>{{matrix_id}}</1>帐户上留言。",
    custom_thumbnail_url: "缩略图URL",
    hide_post: "隐藏帖子",
    unhide_post: "取消隐藏帖子",
    show_hidden_posts: "显示已隐藏的帖子",
    oauth_client_id: "客户端 ID",
    add: "添加",
    comment_sort_type: "评论排序类型",
    cannot_view_secret_after_saving: "密钥保存后将无法查看",
    leaving_admin_team: "正在离开管理团队",
    upvote_percentage: "{{formattedCount}}% 赞",
    auto_expand: "自动展开媒体",
    delete_oauth_provider_are_you_sure: "你确认要删除此提供商吗？",
    username_already_exists: "用户名已存在。",
    content_warning_setting_blurb: "设置内容警告后将显示一条提示，询问用户是否同意继续。",
    rate_limit_info: "Lemmy 可以限制每个 IP 地址对各种操作的请求次数。频率限制字段是该 IP 地址可执行该操作的次数，每秒是频率限制重置前的秒数。",
    block_urls_placeholder: "在此处输入您想要屏蔽的URL，每行一个。支持正则表达式，例如 *.example.com",
    torrent_help: "Lemmy 可使用一种叫 BitTorrent 的技术来查看或播放媒体。<1>点击这里</1>了解更多。",
    post_sort_type: "帖子排序类型",
    oauth_config: "OAuth 配置",
    oauth_providers: "提供商",
    add_oauth_provider: "添加提供商",
    oauth_provider_presets: "预设提供商",
    no_oauth_providers_blurb: "无提供商",
    deleting_oauth_provider: "正在删除提供商...",
    oauth_issuer: "发行商",
    oauth_authorization_endpoint: "授权端点",
    oauth_token_endpoint: "令牌端点",
    authentication: "身份认证",
    oauth_userinfo_endpoint: "用户信息端点",
    oauth_id_claim: "ID 声明",
    oauth_display_name: "显示名称",
    oauth_client_secret: "客户端密钥",
    oauth_scopes: "OAuth 作用域",
    oauth_auto_verify_email: "自动验证邮箱",
    oauth_enabled: "启用提供商",
    couldnt_edit_oauth_provider: "无法编辑 OAuth 提供商。",
    couldnt_delete_oauth_provider: "无法删除 OAuth 提供商。",
    couldnt_create_oauth_provider: "无法创建 OAuth 提供商。",
    oauth_authorization_invalid: "登录授权失败。",
    oauth_login_failed: "登录失败。",
    oauth_registration_closed: "注册通道已关闭。",
    oauth_registration: "允许通过 OAuth 注册",
    hide_hidden_posts: "完全隐藏被隐藏的帖子",
    post_hidden: "帖子已被隐藏",
    post_unhidden: "帖子已被取消隐藏",
    block_urls: "屏蔽 URL",
    content_warning: "内容警告",
    sending_back_message: "好的 👍。将在 {{seconds}} 秒后把你跳转回之前页面。",
    continue: "继续",
    go_back: "返回",
    user_moderation_history: "{{user}} 的管理历史",
    comment_moderation_history: "评论管理历史",
    post_moderation_history: "帖子管理历史",
    language_not_allowed: "该语言未被允许",
    edited_post: "帖子已编辑",
    leave_admin_team_confirmation: "您确定要离开管理团队吗？",
    oauth_account_linking_enabled: "启用账号关联",
    registration_for_user: "{{name}} 的注册申请",
    loading_registration: "正在加载注册申请",
    fetch_registration_error: "无法加载注册申请",
    view_registration: "查看注册申请",
    publish_in_time: "在 {{time}} 发布",
    scheduled_publish_time: "计划发布时间",
    post_title_only: "仅帖子标题",
    donation_dialog_message: "像 Lemmy 这样规模的开源项目需要持续不断的工作来管理项目、实现新功能和修复漏洞。Dessalines 和 Nutomic 全职从事这些任务及更多工作。由于没有广告或追踪，我们所有的工作都依靠捐赠来资助。即便如此，每天的时间也几乎不够用，更没有时间做第二份工作。唯一可行的选择是用户捐赠。为了保持项目的可行性，每月需要达到至少 5000 欧元的捐赠目标，这样每位开发者才能获得 2500 欧元的适度工资。如果达到这个目标，我们就可以不再为资金担忧，专注于改进软件，造福所有用户和实例。我们特别依赖定期捐赠，以保障长期开发，使 Lemmy 达到最佳状态。<br/><br/>如果您在捐赠前想了解更多信息，可以考虑与 Reddit 的对比。Reddit 起初是由富有的投资者资助的创业公司。该网站由企业高管管理，随着时间推移，他们与普通用户的联系越来越少。他们的主要目标是让投资者满意并盈利。这导致了一些对用户不友好的决定，比如解雇负责 AMA 的员工、屏蔽第三方应用等。由于 Reddit 是单一网站由单一权威管理，所有用户都必须遵守相同的规则，包括像审查“Luigi”这个名字这样荒谬的规定。<br/><br/>Lemmy 代表了一种全新的社交媒体类型，完全不同于 Reddit。它分布在许多不同的网站上，每个网站都有自己的规则，由真正关心用户的普通人管理。这里没有公司，也没有盈利动机。大部分工作由志愿的实例管理、社区管理和发帖者完成，他们出于热情而非金钱贡献。对用户来说，这非常好，因为没有广告和追踪，也没有亿万富翁接管的可能。此外，没有内置的政治或意识形态限制。您可以将软件用于任何目的，添加自己的限制或审查其内部运作。Lemmy 真正属于每个人。<br/><br/>Nutomic 和 Dessalines，Lemmy 开发者",
    donation_dialog_title: "支持Lemmy发展",
    banned_from_community_badge: "被社区封禁",
    show_content: "显示内容",
    donation_dialog_button_donate: "捐赠",
    donation_dialog_button_hide: "隐藏",
    fedilink: "联邦链接",
    report_community: "举报这个社区",
    private: "私人",
    private_blurb: "只有被批准的用户才能与这个社区互动。",
    post_downvote_federation: "帖子点踩联合",
    comment_upvote_federation: "评论点赞联合",
    comment_downvote_federation: "评论点踩联合",
    added_item_to_list: "添加 {{item}}至 {{list}}",
    removed_item_from_list: "从 {{list}}移除 {{item}}",
    allowlist: "白名单",
    blocklist: "黑名单",
    mark_page_as_read: "将页面标记为已读",
    image_uploaded: "已上传图片",
    image_deleted: "图像已删除",
    active_daily: "活跃天数",
    active_weekly: "活跃周数",
    active_monthly: "活跃月数",
    active_six_months: "活跃半年",
    name_asc: "名称升序",
    name_desc: "名称降序",
    image: "图像",
    upload: "上传",
    enable_private_messages: "启用私人消息",
    upload_and_publish_image_title: "上传这张图片？",
    upload_and_publish_image_desc: "上传的图像将分发到联合实例，无需任何进一步的用户交互。",
    vote_show: "显示",
    vote_show_for_others: "显示给别人看",
    vote_hide: "隐藏",
    liked: "喜欢",
    none: "无",
    rate_limit_import_user_settings: "导入设置",
    disable: "禁用",
    subscribers_local: "本地订阅者",
    auto_mark_fetched_posts_as_read: "自动标记已获取的帖子为已读",
    post_upvote_federation: "帖子点赞联合",
    upvoted: "已赞",
    locking: "锁定中",
    unlocking: "正在解除锁定",
    resend_verification_email: "重新发送验证邮件",
    custom_emoji_created: "自定义表情已创建",
    blocked_all_communities_from_these_instances: "已屏蔽来自这些实例的所有社区",
    tagline_updated: "标语已更新",
    vote_totals_for_user: "用户投票总数",
    note_for_user: "用户须知",
    banned_dialog_title_temporary: "您已被暂时封禁（有效期至{{expires}}）",
    banned_dialog_body: "您无法发帖、投票或进行其他操作。但您可以继续浏览网站，并在设置页面导出您的设置以导入到另一个Lemmy实例、创建备份或删除账户。",
    expand_all_images: "展开所有图片",
    language_browser_default: "浏览器默认",
    theme_instance_default: "实例默认",
    theme_instance_default_compact: "实例默认（紧凑型）",
    disallow_nsfw_content: "禁止工作场所不适宜（NSFW）内容",
    setup_your_site: "设置您的站点",
    edit_your_site: "编辑您的站点",
    post_time_range: "显示最近的帖子",
    blocked_all_users_from_these_instances: "已阻止来自这些实例的所有用户",
    blocked_all_communities_from: "已阻止来自{{instance}}的所有社区",
    blocked_all_users_from: "已阻止来自{{instance}}的所有用户",
    blocked_x: "已阻止 {{item}}",
    unblocked_x: "已解锁{{item}}",
    tagline_deleted: "标语已删除",
    tagline_created: "标语已创建",
    couldnt_create_tagline: "无法创建标语",
    couldnt_update_tagline: "无法更新标语",
    couldnt_delete_tagline: "无法删除标语",
    custom_emoji_updated: "自定义表情已更新",
    custom_emoji_deleted: "自定义表情已删除",
    couldnt_create_custom_emoji: "无法创建自定义表情",
    couldnt_update_custom_emoji: "无法更新自定义表情",
    couldnt_delete_custom_emoji: "无法删除自定义表情",
    hidden: "隐藏",
    back_to_first_page: "第一页",
    posts_per_page: "每页帖子数",
    note_created: "笔记已创建",
    note_deleted: "笔记已删除",
    show_user_vote_totals: "显示用户投票总数",
    create_user_note: "创建用户备注",
    new_account_label: "新账户，创建于7天内",
    last_updated: "最后更新",
    notification_mode_all_posts_and_comments: "所有帖子和评论",
    notification_mode_all_posts: "所有帖子",
    notification_mode_all_comments: "所有评论",
    notification_mode_replies_and_mentions: "回复和提及（默认）",
    notification_mode_mute: "静音",
    notifications_updated: "通知已更新",
    unknown_language: "未知语言",
    registered_date_title: "已注册",
    ban_person_button: "禁止{{name}}",
    banned_dialog_title_permanent: "你已被永久封禁",
    hide_community_reports: "隐藏社区举报",
    show_community_reports: "显示社区举报",
    lock_post: "锁定帖子",
    unlock_post: "帖子锁定解除",
    cross_posted_from_url: "跨站发布自：{{ap_id}}",
    lock_comment: "锁定评论",
    unlock_comment: "评论锁定解除",
    visit_random_community: "随机访问一个社区",
    locked_post_comment_placeholder: "该内容已被锁定，无法评论。",
    one_hour: "一小时",
    six_hours: "六小时",
    twelve_hours: "十二小时",
    one_day: "一天",
    one_week: "一周",
    one_month: "一个月",
    three_months: "三个月",
    six_months: "六个月",
    nine_months: "九个月",
    one_year: "一年",
    all_time: "有史以来",
    custom_time: "自定义时间间隔",
    seconds: "秒",
    days: "天",
    minutes: "分钟",
    hours: "小时",
    weeks: "周",
    months: "月",
    years: "年",
    time_interval: "时间间隔",
    time_unit: "时间单位",
    read: "浏览",
    notifications: "通知",
    keyword_blocks_placeholder: "输入您想要从信息流中屏蔽的任何关键词，每行一个区块。",
    cant_block_yourself: "无法屏蔽自己",
    not_higher_mod: "无法对更高级别的版主进行修改",
    card: "卡片",
    listing_mode: "列表模式",
    disable_email_notifications: "禁用邮件通知",
    couldnt_create: "无法创建",
    no_content_type_header: "没有内容类型标题",
    too_many_scheduled_posts: "您一次不能有超过10个活跃的预定发布帖子",
    max_comment_depth_reached: "已达到最大评论深度",
    invalid_default_post_listing_type: "不能将已订阅或版主视图设为默认帖子列表",
    local_site_not_setup: "本地站点尚未设置",
    missing_totp_secret: "缺少TOTP密钥",
    slurs: "文本包含被本实例屏蔽的侮辱性用语",
    ban_expiration_in_past: "封禁到期时间已过",
    cannot_combine_community_id_and_multi_community_id: "无法同时使用社区ID和多社区ID",
    block_keyword_too_short: "屏蔽关键词过短",
    block_keyword_too_long: "屏蔽关键词过长",
    couldnt_update: "无法更新",
    url_length_overflow: "网址过长",
    small_card: "小卡片",
    keyword_blocks: "屏蔽关键词",
    cant_note_yourself: "无法自行记录",
    cant_block_admin: "无法屏蔽管理员",
    passwords_do_not_match: "密码不匹配",
    pictrs_api_key_not_provided: "Pictrs API密钥缺失",
    not_an_image_type: "不是图像文件类型",
    invalid_image_upload: "上传的图片无效",
    image_upload_disabled: "图片上传功能已禁用",
    not_top_mod: "你不是最高权限的管理员",
    not_higher_admin: "无法对更高级别的管理员进行更改",
    person_is_blocked: "用户被屏蔽",
    community_is_blocked: "社区已屏蔽",
    instance_is_blocked: "实例已屏蔽",
    honeypot_failed: "蜜罐验证失败，你是机器人吗？",
    registration_application_is_pending: "注册正在等待管理员审核",
    already_exists: "项目已存在",
    nsfw_not_allowed: "本实例不允许发布NSFW内容",
    edit_private_message_not_allowed: "您无权编辑此私信",
    application_question_required: "你必须回答申请问题",
    registration_username_required: "注册需要用户名",
    email_already_taken: "该邮箱已被占用",
    username_already_taken: "该用户名已被占用",
    person_is_banned_from_community: "你被该社区封禁了",
    no_id_given: "必须提供名称或ID",
    invalid_name: "无效名称",
    invalid_code_verifier: "OAuth的PKCE code_verifier无效",
    invalid_display_name: "无效的显示名称",
    invalid_body_field: "文本过长或过短",
    alt_text_length_overflow: "替代文本过长",
    couldnt_parse_totp_secret: "解析TOTP密钥失败",
    couldnt_generate_totp: "生成TOTP失败",
    missing_totp_token: "缺少TOTP令牌",
    incorrect_totp_token: "错误的TOTP令牌",
    totp_already_enabled: "您的账户已启用TOTP功能",
    blocked_url: "此实例已屏蔽该URL",
    email_send_failed: "发送邮件失败",
    couldnt_create_image_captcha: "无法创建图片验证码",
    invalid_url_scheme: "无效的URL协议，仅允许http、https和magnet链接",
    contradicting_filters: "无法同时使用‘仅显示喜欢’和‘仅显示不喜欢’的筛选条件",
    too_many_items: "物品过多",
    invalid_unix_time: "无效的Unix时间戳",
    invalid_bot_action: "机器人不允许参与投票",
    tag_not_in_community: "此社区不允许该标签",
    cant_block_local_instance: "无法屏蔽本地实例",
    not_found: "未找到",
    post_schedule_time_must_be_in_future: "帖子发布时间必须设定在未来",
    couldnt_parse_pagination_token: "无效的分页令牌",
    invalid_fetch_limit: "无效的获取限制",
    email_notifications_disabled: "此实例已禁用电子邮件通知",
    multi_community_update_wrong_user: "您无权更新此多社区内容",
    multi_community_entry_limit_reached: "多社区条目数量已达上限",
    cannot_combine_federation_blocklist_and_allowlist: "无法同时使用联邦黑名单和白名单",
    add_community: "新增社区",
    disallowed_x: "不允许的{{item}}",
    collapse_bot_comments: "折叠机器人评论",
    community_removed: "社区已移除",
    community_visibility_unlisted: "不公开",
    community_visibility_unlisted_desc: "这个社区对所有人可见，但不会显示在全局/全部信息流中。",
    community_visibility_local_only_public: "仅本地（公开）",
    community_visibility_local_only_private: "仅本地（私密）",
    community_visibility_local_only_private_desc: "此社区不进行联合，仅对已登录的本地用户可用。",
    community_visibility_private: "私人",
    community_visibility_private_desc: "此社区为私密社区，只有经过版主手动批准的用户才能查看。",
    show_animated_images: "显示动态图像",
    community_pending_follows: "待处理的关注",
    pending_private_community_follows_0: "{{formattedCount}} 个待处理的关注",
    cannot_leave_mod: "无法退出管理员身份",
    stay_logged_in: "保持登录状态",
    allowed_x: "允许的{{item}}",
    community_added: "社区已新增",
    community_visibility_public: "公共",
    community_visibility_local_only_public_desc: "该社区不进行联邦共享，仅对本地用户（包括未登录用户）开放。",
    create_multi_community: "建立多重社区",
    cant_view_private_community_message: "您没有查看此社区的权限。点击关注按钮，等待版主手动批准后即可查看内容。",
    hide_all_media: "隐藏所有媒体",
    domain: "域名",
    multi_communities: "多社区",
    community_visibility_public_desc: "这个社区对所有人可见。",
    share_post: "分享贴子",
    too_many_requests: "请求过多",
    estimated_approval_time: "预计审批时间：{{time}}",
    post_url_only: "仅帖子 URL",
    active_plugins: "活跃插件",
    all_communities: "所有社区",
    all_users: "所有用户",
    restore_community: "恢复社区",
    restored_community: "修复后的社区",
    restored_multi_community: "已修复的多重社区",
    featuring_posts_for_local_instance: "本地实例的精选帖子",
    removing_comments: "删除评论",
    removing_communities: "删除社区",
    banning_from_site: "封禁自整个网站",
    banning_from_communities: "从社区封禁",
    featuring_posts_in_community: "社区热门帖子精选",
    adding_mod_to_community: "为社区添加管理员",
    transferring_communities: "转移社区",
    changing_community_visibility: "更改社区可见性",
    edit_as_mod: "以版主身份编辑",
    x_settings: "<1>item</1> 设置",
    left_mod_team: "您已退出版主团队",
    appoint_mod: "任命版主",
    removing_posts: "删除帖子",
    locking_posts: "锁定帖子",
    locking_comments: "锁定评论",
    adding_admin_to_site: "将管理员添加到站点",
    blocking_a_federated_instance: "阻止联合实例",
    allowing_a_federated_instance: "允许联合实例",
    purging_a_person: "驱逐某人",
    all_mods: "所有版主",
    hide_read_posts: "隐藏已读帖子",
    warn_user: "警告用户",
    warning_sent: "警告已发送",
    purging_a_community: "清除社区",
    purging_a_post: "清除帖子",
    purging_a_comment: "清除评论",
    deleted_community: "已删除的社区",
    deleted_multi_community: "已删除的多社区",
    purge_community_with_name: "清除 {{community}}",
    all_creators: "所有创作者",
    show_subscribed: "显示已订阅",
    show_sidebar: "显示侧栏",
    sort: "排序",
    n_seconds_0: "{{formattedCount}} 秒",
    n_minutes_0: "{{formattedCount}} 分钟",
    n_hours_0: "{{formattedCount}} 小时",
    n_days_0: "{{formattedCount}} 天",
    n_months_0: "{{formattedCount}} 个月",
    n_weeks_0: "{{formattedCount}} 周",
    n_years_0: "{{formattedCount}} 年",
    time_filter: "时间",
    update: "更新",
    read_terms_and_conditions: "我同意条款和条件。",
    show_unread_only: "仅显示未读",
    show_unresolved_only: "仅显示未解决",
    suggested: "建议",
    tree: "树状",
    allow_instance: "允许实例",
    community_tag_edited: "社区标签已编辑",
    community_tag_deleted: "社区标签已删除",
    oauth_use_external_provider: "使用外部提供商",
    leave_mod_team_confirmation: "您确定要离开管理团队吗？",
    leaving_mod_team: "正在离开管理团队",
    missing_alt_text: "请考虑为此图片或媒体写一段简短的文字描述（替代文本），以帮助视障读者。",
    community_not_federated_title: "社区尚未联合",
    community_not_federated_message: "目前只有本地用户关注该社区。要获得更多关注者，请在 Lemmyverse 中推广它，并分享标识符 <1>communityName</1>。您也可以使用 <2>lemmy-federate.com</2>。",
    dead_community_title: "死社区",
    dead_community_body: "该社区已超过一周未进行联合。新的帖子和评论可能丢失。该实例可能已下线或取消联合。",
    suggested_multi_community: "建议的多社区",
    image_mode: "图片模式",
    store_link_previews: "存储链接预览",
    proxy_all_images: "代理所有图片",
    image_proxy_bypass_domains: "图片代理绕过域名",
    image_upload_timeout_seconds: "图片上传超时（秒）",
    image_max_thumbnail_size: "最大缩略图尺寸（像素）",
    image_max_avatar_size: "用户和社区的最大头像尺寸（像素）",
    image_max_banner_size: "用户和社区的最大横幅尺寸（像素）",
    image_max_upload_size: "帖子/评论图片的最大尺寸（像素）",
    image_allow_video_uploads: "允许视频上传",
    federation_signed_fetch: "联合签名获取",
    community_tag_created: "社区标签已创建",
    tags: "标签",
    summary: "摘要",
  },
} as const;